import { Loader2 } from "lucide-react";
import { Panel } from "@/components/dashboard/Panel";
import { L } from "@/i18n";

export const SectionPanel = ({ title, subtitle, action, query, emptyIcon: Icon, emptyText, errorText, testId, children }) => (
  <Panel title={title} subtitle={subtitle} action={action} testId={testId}>
    {query.isLoading && (
      <div className="py-8 grid place-items-center"><Loader2 className="h-5 w-5 animate-spin text-amber-500" /></div>
    )}
    {query.isError && (
      <p className="py-6 text-center text-sm text-rose-300" data-testid={`${testId}-error`}>{errorText ?? L("Could not load.", "Não foi possível carregar.")}</p>
    )}
    {query.isSuccess && !(query.data?.length) && (
      <div className="py-8 text-center" data-testid={`${testId}-empty`}>
        <Icon className="mx-auto h-6 w-6 text-slate-600" />
        <p className="mt-2 text-sm text-slate-400">{emptyText}</p>
      </div>
    )}
    {query.isSuccess && query.data?.length > 0 && children(query.data)}
  </Panel>
);
